import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import {
  updateDoctorOnlineStatus,
  getRoomCategoryList,
} from "../../api/apiHandler";
import {
  loginStoreData,
  logOutRedirectCall,
} from "../../pages/patient/common/RedirectPathMange";
import styled from "styled-components";
// checked={localStorage.getItem("onlineStatus")}
function Header() {
  const monthCategoryMap = {
    0: [1], // January → Cancer
    1: [2], // February → Cardiovascular
    2: [3], // March → Diabetes
    3: [4], // April → Geriatrics
    4: [5], // May → Hypertension
    5: [6], // June → Mental Health
    6: [7], // July → OB/GY6
    7: [8], // August → Pediatrics
    8: [9], // September → Wellness & Nutrition
    9: [5], // October → Social Service
    10: [1, 6], // November → Cancer + Mental Health
    11: [3, 5], // December → Diabetes + Hypertension
  };
  const currentMonth = new Date().getMonth(); // 0–11
  const monthWiseImages = [
    {
      month: "dec",
      id: 12,
      image: "/assets/images/mental-health-icon.png",
    },
    {
      month: "Nov",
      id: 11,
      image: "/assets/images/mental-health-icon.png",
    },
    {
      month: "Oct",
      id: 10,
      image: "/assets/images/mental-health-icon.png",
    },
    {
      month: "sep",
      id: 9,
      // image: "/assets/images/wellness-icon.png",
      image: "/assets/images/September.png",
    },
    {
      month: " Aug", //aug
      id: 8,
      image: "/assets/images/amber.png",
    },
    {
      month: "July", // july
      id: 7,
      image: "/assets/images/wellness-icon.png",
    },

    {
      month: "june", //june
      id: 6,
      image: "/assets/images/social-service.png",
    },
    {
      month: "May → Hypertension", // May → Hypertension
      id: 5,
      image: "/assets/images/hypertension-icon.jpg",
    },
    {
      month: "April → Geriatrics", // April → Geriatrics
      id: 4,
      image: "/assets/images/geriatrics.png",
    },
    {
      month: "March → Diabetes", // March → Diabetes
      id: 3,
      image: "/assets/images/diabetes-icon.png",
    },
    {
      month: "February → Cardiovascular", // February → Cardiovascular
      id: 2,
      image: "/assets/images/cardiovascular.png",
    },
    {
      month: "January → Cancer", // January → Cancer
      id: 1,
      image: "/assets/images/cancer-icon.png",
    },
  ];
  const categorys = [
    {
      value: "Mental Health",
      label: "Mental Health",
      id: 10,
      image: "/assets/images/mental-health-icon.png",
    },
    {
      value: "Wellness & Nutrition",
      label: "Wellness & Nutrition",
      id: 9,
      image: "/assets/images/wellness-icon.png",
    },
    {
      value: "Pediatrics",
      label: "Pediatrics",
      id: 8,
      image: "/assets/images/pediatrics.png",
    },
    {
      value: "OB/GYN",
      label: "OB/GYN",
      id: 7,
      image: "/assets/images/ob-gyn1.jpg",
    },

    {
      value: "Social Service",
      label: "Social Service",
      id: 6,
      image: "/assets/images/social-service.png",
    },
    {
      value: "Hypertension",
      label: "Hypertension",
      id: 5,
      image: "/assets/images/hypertension-icon.jpg",
    },
    {
      value: "Geriatrics",
      label: "Geriatrics",
      id: 4,
      image: "/assets/images/geriatrics.png",
    },
    {
      value: "Diabetes",
      label: "Diabetes",
      id: 3,
      image: "/assets/images/diabetes-icon.png",
    },
    {
      value: "Cardiovascular",
      label: "Cardiovascular",
      id: 2,
      image: "/assets/images/cardiovascular.png",
    },
    {
      value: "Cancer",
      label: "Cancer",
      id: 1,
      image: "/assets/images/cancer-icon.png",
    },
  ];
  const formatCommunityPath = (value) => {
    return (
      value
        .toLowerCase()
        .replace(/&/g, "")
        .replace(/[^\w\s]/gi, "")
        .replace(/\s+/g, "") + "/community"
    );
  };
  const [onlineStatusCheck, setOnlineStatusCheck] = useState(0);
  const [category, setCategory] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const activeCategoryIds = monthCategoryMap[currentMonth] || [];

  const matchedCategories = monthWiseImages.filter((cat) =>
    activeCategoryIds.includes(cat.id)
  );
  console.log(matchedCategories, "matchedCategories");
  const [monthMatchedImg, setMonthMatchedImg] = useState();
  useEffect(() => {
    setMonthMatchedImg(matchedCategories?.[0]?.image);
  }, [monthMatchedImg]);
  useEffect(() => {
    // Split the path and get the category part (index 2 => /doctor/**geriatrics**/community)
    const segments = location.pathname.split("/");
    const categorySlug = segments[2]; // assuming fixed path format

    if (!categorySlug) return;

    // Match category label ignoring case and special characters

    const matched = categorys.find(
      (cat) =>
        cat.label.toLowerCase().replace(/[^a-z]/gi, "") ===
        categorySlug.toLowerCase().replace(/[^a-z]/gi, "")
    );

    if (matched) {
      setSelectedImage(matched.image);
    } else {
      setSelectedImage(null);
    }
  }, [location]);
  function logoutFun() {
    logOutRedirectCall();
  }
  function loginFun() {
    navigate("/log-in");
  }
  function signupFun() {
    navigate("/signup");
  }
  useEffect(() => {
    setOnlineStatusCheck(localStorage.getItem("onlineStatus"));
  }, []);

  useEffect(() => {
    if (localStorage.getItem("user_login_type_role")) {
      getRoomCategoryList({}).then((response) => {
        response = JSON.parse(response);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          console.log("response.dataaa==>", response.data.data);
          const Category = response?.data?.data?.map((obj) => {
            return { value: obj.name, label: obj.name, id: obj.id };
          });
          setCategory(Category);
        } else {
        }
      });
    }
  }, []);
  const onSubmit = async (data) => {
    try {
      setOnlineStatusCheck(data);
      var params = {
        onlineStatus: data,
      };

      updateDoctorOnlineStatus(params).then((response) => {
        response = JSON.parse(response);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          localStorage.setItem("onlineStatus", response.data.onlineStatus);

          // loginStoreData(response.data)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: response.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: response.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    } catch (e) {
      setOnlineStatusCheck(!data);
      console.log("errorr--->", e);
    }
  };

  //check user login or not
  if (
    localStorage.getItem("user_login_type_role", false) &&
    localStorage.getItem("user_login_type_role") == 1
  ) {
    return (
      <header>
        <nav className="navbar navbar-expand-lg navbar-light bg-white header-nav">
          <div className="container">
            <Link to="/patient/home" className="navbar-brand">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/icon/logo.svg"}
                alt=""
              />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-2">
                <svg
                  width="45"
                  height="45"
                  viewBox="0 0 20 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00001 16V11H12V16C12 16.55 12.45 17 13 17H16C16.55 17 17 16.55 17 16V9H18.7C19.16 9 19.38 8.43 19.03 8.13L10.67 0.600001C10.29 0.260001 9.71001 0.260001 9.33001 0.600001L0.970007 8.13C0.630007 8.43 0.840006 9 1.30001 9H3.00001V16C3.00001 16.55 3.45001 17 4.00001 17H7.00001C7.55001 17 8.00001 16.55 8.00001 16Z"
                    fill="#216fc8"
                  />
                </svg>
                <li className=" ">
                  <Link
                    to="/patient/home"
                    className="nav-link rounded text-white  mb-0 px-3"
                    style={{
                      backgroundColor: "#216fc8",
                      padding: "10px 0",
                    }}
                  >
                    Home
                  </Link>
                </li>

                <li className="nav-item">
                  <div className="nav-item dropdown">
                    <Link
                      to="#"
                      className="mb-0 awareness-dropdown dropdown-toggle nav-link starpilot-btn p-0"
                      id="navbarDropdown1"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/starpilot.png"
                        }
                        alt=""
                      />
                      <p className="nav-link nav-text m-0">SP</p>
                    </Link>

                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdownMain"
                    >
                      {/* Sp Clergy */}
                      <li className="nav-item dropdown border-0 w-full">
                        <button
                          className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                          id="navbarDropdownClergy"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onClick={(e) => e.stopPropagation()} // prevent parent close
                        >
                          SP Clergy
                        </button>

                        <ul
                          className="dropdown-menu"
                          aria-labelledby="navbarDropdownClergySingle"
                        >
                          <li className="nav-item dropdown border-0 w-full">
                            <button
                              className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                              id="navbarDropdownClergySingle"
                              role="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              onClick={(e) => e.stopPropagation()}
                            >
                              Single-User
                            </button>

                            <ul
                              className="dropdown-menu"
                              aria-labelledby="navbarDropdownClergySingle"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to={`/patient-priest/starpilot?isPriestMeeting=${true}`}
                                >
                                  Single-User
                                </Link>
                              </li>
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to={`/patient-priest/single-user-history?isPriestMeeting=${true}`}
                                >
                                  Single-User-Records
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li className="nav-item dropdown border-0 w-full">
                            <button
                              className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                              id="navbarDropdownClergyMulti"
                              role="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              onClick={(e) => e.stopPropagation()}
                            >
                              Multi-User
                            </button>

                            <ul
                              className="dropdown-menu"
                              aria-labelledby="navbarDropdownClergyMulti"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to={`/patient/priest-list?isPriestMeeting=${true}`}
                                >
                                  Start
                                </Link>
                              </li>
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to={`/patient-priest/meeting-status?isPriestMeeting=${true}`}
                                >
                                  Join
                                </Link>
                              </li>
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to={`/patient-priest/meeting-status?isPriestMeeting=${true}`}
                                >
                                  Multi-User Records and Status
                                </Link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>

                      {/* Sp Doctor */}
                      <li className="nav-item dropdown border-0 w-full mt-2">
                        <button
                          className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                          id="navbarDropdownDoctor"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onClick={(e) => e.stopPropagation()}
                        >
                          SP Doctor
                        </button>

                        <ul
                          className="dropdown-menu"
                          aria-labelledby="navbarDropdownDoctor"
                        >
                          <li className="nav-item dropdown border-0 w-full">
                            <button
                              className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                              id="navbarDropdownClergySingle"
                              role="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              onClick={(e) => e.stopPropagation()}
                            >
                              Single-User
                            </button>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="navbarDropdownClergySingle"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to="/patient/starpilot"
                                >
                                  Single-User
                                </Link>
                              </li>
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to={`/patient/single-user-history?isPriestMeeting=${false}`}
                                >
                                  Single-User-Records
                                </Link>
                              </li>
                            </ul>{" "}
                          </li>
                          <li className="nav-item dropdown border-0 w-full">
                            <button
                              className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                              id="navbarDropdownDoctorMulti"
                              role="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              onClick={(e) => e.stopPropagation()}
                            >
                              Multi-User
                            </button>

                            <ul
                              className="dropdown-menu"
                              aria-labelledby="navbarDropdownDoctorMulti"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to="/patient/doctor-list"
                                >
                                  Start
                                </Link>
                              </li>
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to="/patient/meeting-status"
                                >
                                  Join
                                </Link>
                              </li>
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to={`/patient/meeting-status?isPriestMeeting=${false}`}
                                >
                                  Multi-User Records and Status
                                </Link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link starpilot-btn p-0"
                    to="/patient/point-of-care"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icon/poc-icon.png"
                      }
                      alt=""
                    />
                    <p className="nav-link nav-text mb-0">POC</p>
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <Link
                    to="#"
                    className="nav-link awareness-dropdown dropdown-toggle"
                    id="navbarDropdown1"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {/* selectedImage ? selectedImage : */}
                    <img
                      src={process.env.PUBLIC_URL + monthMatchedImg}
                      alt="image"
                    />
                  </Link>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown1"
                  >
                    {category.map((cat) => (
                      <li key={cat.id}>
                        <Link
                          className="dropdown-item"
                          to={`/patient/${formatCommunityPath(cat.value)}`}
                        >
                          {cat.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/patient/community"
                    className="nav-link awareness-dropdown dropdown-toggle"
                    // id="navbarDropdown1"
                    // role="button"
                    // data-bs-toggle="dropdown"
                    // aria-expanded="false"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icon/prayer.svg"
                      }
                      alt="image"
                    />
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {/* <img src={localStorage.getItem("profile_image")} alt="User" width="30px"/> */}
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icon/user-blue-icon.png"
                      }
                      className="dropdown-icon"
                      alt="User"
                    />
                  </Link>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <li>
                      <Link
                        to="/patient/edit-profile"
                        className="dropdown-item"
                      >
                        My Profile
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/change-password&security"
                        className="dropdown-item"
                      >
                        Change Password & Security
                      </Link>
                    </li>
                    <li>
                      <Link to="/patient/feedback" className="dropdown-item">
                        Feedback
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/patient/feedbacklist"
                        className="dropdown-item"
                      >
                        My Feedback List
                      </Link>
                    </li>
                    <li>
                      <Link to="/patient/support" className="dropdown-item">
                        Help & Support
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/patient/point-of-care"
                        className="dropdown-item"
                      >
                        Point of care
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/patient/my-appointments"
                      >
                        My Appointments
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/patient/meeting-status"
                      >
                        Meeting Status & Records
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/patient/permission-code"
                      >
                        Permission Code
                      </Link>
                    </li>
                    {/* <li>
                      <Link className="dropdown-item" to="/patient/ocr">
                        OCR
                      </Link>
                    </li> */}
                  </ul>
                </li>
              </ul>
              <div className="ms-3">
                <button
                  className="logout-btn"
                  onClick={logoutFun}
                  style={{
                    padding: "12px 20px",
                  }}
                >
                  <i className="mdi mdi-power text-danger"></i> Logout
                </button>
              </div>
            </div>
          </div>
        </nav>
      </header>
    );
  } else if (
    localStorage.getItem("user_login_type_role", false) &&
    (localStorage.getItem("user_login_type_role") == 2 ||
      localStorage.getItem("user_login_type_role") == 3)
  ) {
    return (
      <header>
        <nav className="navbar navbar-expand-lg navbar-light bg-white header-nav">
          <div className="container">
            <Link to="/doctor/home" className="navbar-brand">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/icon/logo.svg"}
                alt=""
              />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-2 align-items-center">
                <svg
                  width="45"
                  height="45"
                  viewBox="0 0 20 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00001 16V11H12V16C12 16.55 12.45 17 13 17H16C16.55 17 17 16.55 17 16V9H18.7C19.16 9 19.38 8.43 19.03 8.13L10.67 0.600001C10.29 0.260001 9.71001 0.260001 9.33001 0.600001L0.970007 8.13C0.630007 8.43 0.840006 9 1.30001 9H3.00001V16C3.00001 16.55 3.45001 17 4.00001 17H7.00001C7.55001 17 8.00001 16.55 8.00001 16Z"
                    fill="#216fc8"
                  />
                </svg>
                <li className=" ">
                  <Link
                    to="/doctor/home"
                    className="nav-link rounded text-white  mb-0 px-3"
                    style={{
                      backgroundColor: "#216fc8",
                      padding: "10px 0",
                    }}
                  >
                    Home
                  </Link>
                </li>

                <li className="nav-item">
                  <div className="nav-item dropdown">
                    <Link
                      to="#"
                      className=" mb-0 awareness-dropdown dropdown-toggle nav-link starpilot-btn p-0"
                      id="navbarDropdown1"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/starpilot.png"
                        }
                        alt=""
                      />
                      <p className="nav-link nav-text m-0">SP</p>
                    </Link>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown1"
                    >
                      <li>
                        <div className="nav-item dropdown border-0 w-full">
                          <button
                            className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                            id="navbarDropdown2"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={(e) => e.stopPropagation()} // Prevent parent dropdown from closing
                          >
                            Single-User
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="navbarDropdown2"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/doctor/starpilot"
                              >
                                Single-User
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/doctor/single-user-history"
                              >
                                Single-User-Records
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li>
                        {/* <Link
                          className="dropdown-item"
                          to="/doctor/meeting-status"
                        >
                          Multi-User
                        </Link> */}
                        <div className="nav-item dropdown border-0 w-full">
                          <button
                            className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                            id="navbarDropdown2"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={(e) => e.stopPropagation()} // Prevent parent dropdown from closing
                          >
                            Multi-User
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="navbarDropdown2"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/doctor/meeting-status"
                              >
                                Multi-User
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/doctor/meeting-status"
                              >
                                Multi-User Records and Status
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li>
                        <div className="nav-item dropdown border-0 w-full">
                          <button
                            className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                            id="navbarDropdown2"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={(e) => e.stopPropagation()} // Prevent parent dropdown from closing
                          >
                            Meeting-Single-mic
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="navbarDropdown2"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/meeting-single-mic"
                              >
                                Meeting-Single-mic
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/doctor/meeting-single-mic-history"
                              >
                                Meeting-Single-mic-Records
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item dropdown">
                  <Link
                    to="/doctor/point-of-care"
                    className="nav-link starpilot-btn p-0 dropdown-toggle"
                    id="navbarDropdown"
                    role="button"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icon/poc-icon.png"
                      }
                      alt=""
                    />
                    <p className="nav-link nav-text mb-0">POC</p>
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <Link
                    to="#"
                    className="nav-link awareness-dropdown dropdown-toggle"
                    id="navbarDropdown1"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src={process.env.PUBLIC_URL + monthMatchedImg}
                      alt="image"
                    />
                  </Link>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown1"
                  >
                    {category.map((cat) => (
                      <li key={cat.id}>
                        <Link
                          className="dropdown-item"
                          to={`/doctor/${formatCommunityPath(cat.value)}`}
                        >
                          {cat.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="nav-item">
                  <label
                    htmlFor="custom-switch"
                    className="d-block mb-0 p-0 nav-link active"
                  >
                    Status
                  </label>
                  <Form.Check // prettier-ignore
                    type="switch"
                    onChange={(x) => onSubmit(x.target.checked)}
                    id="custom-switch"
                    checked={onlineStatusCheck == 1 ? true : false}
                  />
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/doctor/community"
                    className="nav-link awareness-dropdown dropdown-toggle"
                    // id="navbarDropdown1"
                    // role="button"
                    // data-bs-toggle="dropdown"
                    // aria-expanded="false"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icon/prayer.svg"
                      }
                      alt="image"
                    />
                  </Link>
                  {/* <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown1"
                  >
                    <li>
                      <Link className="dropdown-item" to="/priest/community">
                        Priest Community
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/doctor/chatmoslem">
                        Moslem
                      </Link>
                    </li>
                  </ul> */}
                </li>
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {/* <img src={localStorage.getItem("profile_image")} alt="User" width="30px"/> */}
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icon/user-blue-icon.png"
                      }
                      className="dropdown-icon"
                      alt="User"
                    />
                  </Link>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <li>
                      <Link to="/doctor/edit-profile" className="dropdown-item">
                        My Profile
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/change-password&security"
                        className="dropdown-item"
                      >
                        Change Password & Security
                      </Link>
                    </li>
                    <li>
                      <Link to="/doctor/feedback" className="dropdown-item">
                        Feedback
                      </Link>
                    </li>
                    <li>
                      <Link to="/doctor/feedbacklist" className="dropdown-item">
                        My Feedback List
                      </Link>
                    </li>
                    <li>
                      <Link to="/doctor/support" className="dropdown-item">
                        Help & Support
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/doctor/point-of-care"
                        className="dropdown-item"
                      >
                        Point of care
                      </Link>
                    </li>
                    <li>
                      <Link to="/doctor/set-timeslot" className="dropdown-item">
                        Set Appointment Timeslots
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/doctor/meeting-status"
                        className="dropdown-item"
                      >
                        Meeting Status & Records
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/doctor/patient-waiting"
                        className="dropdown-item"
                      >
                        Patient Waiting
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/doctor/permission-code-request"
                        className="dropdown-item"
                      >
                        Permission Code Request
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/doctor/ocr" className="dropdown-item">
                        OCR
                      </Link>
                    </li> */}
                  </ul>
                </li>
              </ul>
              <div className="ms-3">
                <button
                  className="logout-btn"
                  onClick={logoutFun}
                  style={{
                    padding: "12px 20px",
                  }}
                >
                  <i className="mdi mdi-power text-danger"></i> Logout
                </button>
              </div>
            </div>
          </div>
        </nav>
      </header>
    );
  } else if (
    localStorage.getItem("user_login_type_role", false) &&
    localStorage.getItem("user_login_type_role") == 4
  ) {
    return (
      <header>
        <nav className="navbar navbar-expand-lg navbar-light bg-white header-nav">
          <div className="container">
            <Link to="/priest/home" className="navbar-brand">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/icon/logo.svg"}
                alt=""
              />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-2 align-items-center">
                <svg
                  width="45"
                  height="45"
                  viewBox="0 0 20 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00001 16V11H12V16C12 16.55 12.45 17 13 17H16C16.55 17 17 16.55 17 16V9H18.7C19.16 9 19.38 8.43 19.03 8.13L10.67 0.600001C10.29 0.260001 9.71001 0.260001 9.33001 0.600001L0.970007 8.13C0.630007 8.43 0.840006 9 1.30001 9H3.00001V16C3.00001 16.55 3.45001 17 4.00001 17H7.00001C7.55001 17 8.00001 16.55 8.00001 16Z"
                    fill="#216fc8"
                  />
                </svg>
                <li className=" ">
                  <Link
                    to="/priest/home"
                    className="nav-link rounded text-white  mb-0 px-3"
                    style={{
                      backgroundColor: "#216fc8",
                      padding: "10px 0",
                    }}
                  >
                    Home
                  </Link>
                </li>

                <li className="nav-item">
                  <div className="nav-item dropdown">
                    <Link
                      to="#"
                      className=" mb-0 awareness-dropdown dropdown-toggle nav-link starpilot-btn p-0"
                      id="navbarDropdown1"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/starpilot.png"
                        }
                        alt=""
                      />
                      <p className="nav-link nav-text m-0">SP</p>
                    </Link>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown1"
                    >
                      <li>
                        <div className="nav-item dropdown border-0 w-full">
                          <button
                            className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                            id="navbarDropdown2"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={(e) => e.stopPropagation()} // Prevent parent dropdown from closing
                          >
                            Single-User
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="navbarDropdown2"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/priest/starpilot"
                              >
                                Single-User
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/priest/single-user-history"
                              >
                                Single-User-Records
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li>
                        <div className="nav-item dropdown border-0 w-full">
                          <button
                            className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                            id="navbarDropdown2"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={(e) => e.stopPropagation()} // Prevent parent dropdown from closing
                          >
                            Multi-User
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="navbarDropdown2"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/priest/meeting-status"
                              >
                                Multi-User
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/priest/meeting-status"
                              >
                                Multi-User Records and Status
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li>
                        <div className="nav-item dropdown border-0 w-full">
                          <button
                            className="border-0 dropdown-toggle py-0 px-3 w-100 text-start bg-transparent"
                            id="navbarDropdown2"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={(e) => e.stopPropagation()} // Prevent parent dropdown from closing
                          >
                            Meeting-Single-mic
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="navbarDropdown2"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/meeting-single-mic"
                              >
                                Meeting-Single-mic
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/priest/meeting-single-mic-history"
                              >
                                Meeting-Single-mic-Records
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item dropdown">
                  <Link
                    to="/priest/point-of-care"
                    className="nav-link starpilot-btn p-0 dropdown-toggle "
                    id="navbarDropdown"
                    role="button"
                    onClick={(e) => e.preventDefault()} // stop navigation
                    aria-disabled="true"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icon/poc-icon.png"
                      }
                      alt=""
                    />
                    <p className="nav-link nav-text mb-0">POC</p>
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <Link
                    to="#"
                    className="nav-link awareness-dropdown dropdown-toggle"
                    id="navbarDropdown1"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src={process.env.PUBLIC_URL + monthMatchedImg}
                      alt="image"
                    />
                  </Link>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown1"
                  >
                    {category.map((cat) => (
                      <li key={cat.id}>
                        <Link
                          className="dropdown-item"
                          to={`/priest/${formatCommunityPath(cat.value)}`}
                        >
                          {cat.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="nav-item">
                  <label
                    htmlFor="custom-switch"
                    className="d-block mb-0 p-0 nav-link active"
                  >
                    Status
                  </label>
                  <Form.Check // prettier-ignore
                    type="switch"
                    onChange={(x) => onSubmit(x.target.checked)}
                    id="custom-switch"
                    checked={onlineStatusCheck == 1 ? true : false}
                  />
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/priest/community"
                    className="nav-link awareness-dropdown dropdown-toggle"
                    // id="navbarDropdown1"
                    // role="button"
                    // data-bs-toggle="dropdown"
                    // aria-expanded="false"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icon/prayer.svg"
                      }
                      alt="image"
                    />
                  </Link>
                  {/* <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown1"
                  >
                    <li>
                      <Link className="dropdown-item" to="/priest/community">
                        Priest Community
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/doctor/chatmoslem">
                        Moslem
                      </Link>
                    </li>
                  </ul> */}
                </li>
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {/* <img src={localStorage.getItem("profile_image")} alt="User" width="30px"/> */}
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icon/user-blue-icon.png"
                      }
                      className="dropdown-icon"
                      alt="User"
                    />
                  </Link>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <li>
                      <Link to="/priest/edit-profile" className="dropdown-item">
                        My Profile
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/change-password&security"
                        className="dropdown-item"
                      >
                        Change Password & Security
                      </Link>
                    </li>
                    <li>
                      <Link to="/priest/feedback" className="dropdown-item">
                        Feedback
                      </Link>
                    </li>
                    <li>
                      <Link to="/priest/feedbacklist" className="dropdown-item">
                        My Feedback List
                      </Link>
                    </li>
                    <li>
                      <Link to="/priest/support" className="dropdown-item">
                        Help & Support
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        to="/priest/point-of-care"
                        className="dropdown-item"
                      >
                        Point of care
                      </Link>
                    </li> */}
                    <li>
                      <Link to="/priest/set-timeslot" className="dropdown-item">
                        Set Appointment Timeslots
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/priest/meeting-status"
                        className="dropdown-item"
                      >
                        Meeting Status & Records
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        to="/priest/patient-waiting"
                        className="dropdown-item"
                      >
                        Patient Waiting
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link
                        to="/priest/permission-code-request"
                        className="dropdown-item"
                      >
                        Permission Code Request
                      </Link>
                    </li> */}
                  </ul>
                </li>
              </ul>
              <div className="ms-3">
                <button
                  className="logout-btn"
                  onClick={logoutFun}
                  style={{
                    padding: "12px 20px",
                  }}
                >
                  <i className="mdi mdi-power text-danger"></i> Logout
                </button>
              </div>
            </div>
          </div>
        </nav>
      </header>
    );
  } else {
    return (
      <HeaderWrpper>
        <nav className="navbar navbar-expand-lg navbar-light bg-white header-nav">
          <div className="container">
            <div className="d-flex gap-10 align-items-center">
              <button className="logout-btn d-lg-none" onClick={loginFun}>
                <i className="mdi mdi-power text-danger"></i> Login
              </button>
              <Link to="/" className="navbar-brand">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/logo--b.png"}
                  alt=""
                />
              </Link>
            </div>
            <div className="d-lg-none d-flex align-items-center gap-10">
              <button
                className="navbar-toggler p-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <button
                className="logout-btn "
                style={{ background: "#fc7c37" }}
                onClick={signupFun}
              >
                <i className="mdi mdi-power text-danger"></i> Sign Up
              </button>
            </div>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-2">
                <li className="nav-item">
                  <Link
                    to="/"
                    className={`nav-link pb-1 ${
                      location.pathname === "/" && "active"
                    }`}
                  >
                    Home
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    to="/about-us"
                    className={`nav-link pb-1 ${
                      location.pathname === "/about-us" && "active"
                    }`}
                  >
                    About us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/contact-us"
                    className={`nav-link pb-1 ${
                      location.pathname === "/contact-us" && "active"
                    }`}
                  >
                    Contact
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/service-page"
                    className={`nav-link pb-1 ${
                      location.pathname === "/service-page" && "active"
                    }`}
                  >
                    Services
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/policy"
                    className={`nav-link pb-1 ${
                      location.pathname === "/policy" && "active"
                    }`}
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/terms"
                    className={`nav-link pb-1 ${
                      location.pathname === "/terms" && "active"
                    }`}
                  >
                    Terms of Use
                  </Link>
                </li>
              </ul>
              <div className="ms-3 d-lg-block d-none">
                <button className="logout-btn" onClick={loginFun}>
                  <i className="mdi mdi-power text-danger"></i> Login
                </button>
              </div>
              <div className="ms-3 d-lg-block d-none">
                <button
                  className="logout-btn"
                  style={{ background: "#fc7c37" }}
                  onClick={signupFun}
                >
                  <i className="mdi mdi-power text-danger"></i> Sign Up
                </button>
              </div>
            </div>
          </div>
        </nav>
      </HeaderWrpper>
    );
  }
}

const HeaderWrpper = styled.div`
  a {
    &.active {
      border-bottom: 1px solid #216fc8;
    }
  }
  @media (max-width: 360px) {
    .logout-btn {
      padding: 5px 8px;
      font-size: 12px;
    }
  }
`;

export default Header;
